














































import { computed, defineComponent } from "@vue/composition-api";
import { MessageThread } from "@scrile/api-provider/dist/api/MessageThreadsProvider";
import { Subscription } from "@scrile/api-provider/dist/api/SubscriptionProvider";
import { checkAuthorities } from "@scrile/tools/dist/lib/SecurityHelpers";
import useAuthUser from "@/hooks/useAuthUser";
import { $t } from "@/lib/i18nHelpers";
import { BaseMenuItem } from "@/types";
import BaseIconButton from "@/components/BaseIconButton";
import BaseMenu from "@/components/BaseMenu";
import BasePage from "@/components/BasePage";
import EmptyContent from "@/components/EmptyContent";
import InfiniteScroll from "@/components/InfiniteScroll";
import PageTitle from "@/components/PageTitle";
import MessageThreadItem from "./MessageThreadItem.vue";
import MessageThreadsSort from "./MessageThreadsSort.vue";
import { MessageSortTypeEnum } from "../types";

export default defineComponent({
  name: "MessageThreadsView",
  components: {
    InfiniteScroll,
    EmptyContent,
    BasePage,
    BaseMenu,
    BaseIconButton,
    PageTitle,
    MessageThreadItem,
    MessageThreadsSort,
  },
  props: {
    loading: { type: Boolean, required: true },
    allowMassMessage: { type: Boolean, required: true },
    messageThreadList: { type: Array as () => MessageThread[], required: true },
    authUserId: { type: String, required: true },
    subscribersList: { type: Object as () => Record<string, Subscription>, required: true },
    scroll: { type: Boolean, required: true },
    sortItems: { type: Array as () => string[], required: true },
    currentSortItem: { type: Number as () => MessageSortTypeEnum, required: true },
  },
  setup(props) {
    const { authorities } = useAuthUser();
    const allowMassMessageStat = computed(() =>
      checkAuthorities(authorities.value, ["updateMyContentPrice", "getMyMassMessageStat"])
    );
    const emptyThreads = computed(() => !props.loading && props.messageThreadList.length === 0);
    const menuItems = computed<BaseMenuItem[]>(() => {
      const items = [];
      if (props.allowMassMessage) {
        items.push({
          name: "sendMassMessage",
          text: $t("Send Mass message"),
          icon: "sci-send",
        });
      }
      if (allowMassMessageStat.value) {
        items.push({
          name: "statistics",
          text: $t("Statistics"),
          icon: "sci-bar",
        });
      }
      return items;
    });

    const emptyContentText = computed(() =>
      props.currentSortItem === MessageSortTypeEnum.DEFAULT ? $t("No messages yet") : $t("No unread messages")
    );
    const getSubscriptionCost = (id: string) => {
      return props.subscribersList[id]?.amount ?? 0;
    };

    return { allowMassMessageStat, emptyThreads, menuItems, emptyContentText, getSubscriptionCost };
  },
});
